import type { FarmFormData } from "@/schemas/farm-schema";

export function buildFarmFormData(data: FarmFormData): FormData {
    const fd = new FormData();

    fd.append("name", data.name);
    fd.append("totalBirds", data.totalBirds.toString());
    fd.append("idRing", data.idRing);
    if (data.community) fd.append("community", data.community);
    if (data.city) fd.append("city", data.city);

    if (data.birdType && Array.isArray(data.birdType)) {
        data.birdType.forEach((type: string, i: number) => {
            fd.append(`birdType[${i}]`, type);
        });
    }

    if (data.contact) {
        if (data.contact.whatsapp)
            fd.append("contact[whatsapp]", data.contact.whatsapp);
        if (data.contact.instagram)
            fd.append("contact[instagram]", data.contact.instagram);
        if (data.contact.facebook)
            fd.append("contact[facebook]", data.contact.facebook);
        if (data.contact.tiktok)
            fd.append("contact[tiktok]", data.contact.tiktok);
    }

    const appendParent = (
        prefix: string,
        parentData: typeof data.mother | typeof data.father,
    ) => {
        if (!parentData) return;
        fd.append(`${prefix}[identity]`, parentData.identity);
        fd.append(`${prefix}[ownerName]`, parentData.ownerName);
        fd.append(`${prefix}[ownerCity]`, parentData.ownerCity);
        if (parentData.topChampions) {
            fd.append(`${prefix}[topChampions]`, parentData.topChampions);
        } else {
            fd.append(`${prefix}[topChampions]`, "");
        }
        if (parentData.certUrl instanceof File) {
            fd.append(`${prefix}[certUrl]`, parentData.certUrl);
        } else if (typeof parentData.certUrl === "string") {
            fd.append(`${prefix}[certUrl]`, parentData.certUrl);
        } else {
            fd.append(`${prefix}[certUrl]`, "");
        }
    };
    appendParent("mother", data.mother);
    appendParent("father", data.father);

    if (data.achievements && Array.isArray(data.achievements)) {
        data.achievements.forEach((ach, i: number) => {
            if (ach.id) fd.append(`achievements[${i}][id]`, ach.id.toString());
            fd.append(`achievements[${i}][rank]`, ach.rank.toString());
            fd.append(`achievements[${i}][level]`, ach.level);
            if (ach.certUrl instanceof File) {
                fd.append(`achievements[${i}][certUrl]`, ach.certUrl);
            } else if (typeof ach.certUrl === "string") {
                fd.append(`achievements[${i}][certUrl]`, ach.certUrl);
            } else {
                fd.append(`achievements[${i}][certUrl]`, "");
            }
        });
    }

    if (data.cover instanceof File) {
        fd.append("cover", data.cover);
    } else if (typeof data.cover === "string") {
        fd.append("cover", data.cover);
    } else {
        fd.append("cover", "");
    }

    if (data.gallery) {
        if (data.gallery.img && Array.isArray(data.gallery.img)) {
            data.gallery.img.forEach((img, i: number) => {
                if (img instanceof File) {
                    fd.append(`gallery[img][${i}]`, img);
                } else if (typeof img === "string") {
                    fd.append(`gallery[img][${i}]`, img);
                }
            });
        }
        if (data.gallery.video) {
            fd.append("gallery[video]", data.gallery.video);
        }
    }

    return fd;
}
